import { http } from 'services';

// instance - Get logo
export function getIndexList(params, cbSuccess, cbError) {
  http.get(
    'allergens',
    params,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function addAllergen(data, cbSuccess, cbError) {
  http.post(
    'allergens',
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getAllergenDetails(id, cbSuccess, cbError) {
  http.get(
    `allergens/${id}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function saveDetails(id, data, cbSuccess, cbError) {
  http.patch(
    `allergens/${id}`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function deleteAllergen(id, cbSuccess, cbError) {
  http.delete(
    `allergens/${id}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}




// WEBPACK FOOTER //
// ./src/api/api-allergens/api-allergens-base.js